import script from "./BarraControles.vue?vue&type=script&setup=true&lang=js"
export * from "./BarraControles.vue?vue&type=script&setup=true&lang=js"

import "./BarraControles.vue?vue&type=style&index=0&id=128c72b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128c72b0"]])

export default __exports__